import { render, staticRenderFns } from "./EditEventInfo.vue?vue&type=template&id=6a87d05e&scoped=true"
import script from "./EditEventInfo.vue?vue&type=script&lang=js"
export * from "./EditEventInfo.vue?vue&type=script&lang=js"
import style0 from "./EditEventInfo.vue?vue&type=style&index=0&id=6a87d05e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a87d05e",
  null
  
)

export default component.exports